import type { TransferOrderListFilters } from '../transfer-order-list-filters/index.js';
import { dateToParam } from './date-to-param.js';
import type { TransferOrderWorkspaceSearch } from './transfer-order-workspace-search.js';

export function workspaceSearchFromFilters(
  filters: TransferOrderListFilters,
): Pick<
  TransferOrderWorkspaceSearch,
  'statusIds' | 'brandId' | 'warehouseId' | 'createdFrom' | 'createdTo'
> {
  return {
    statusIds: filters.statusIds.length > 0 ? filters.statusIds : undefined,
    brandId: filters.brandId || undefined,
    warehouseId: filters.warehouseId || undefined,
    createdFrom: dateToParam(filters.dateCreated?.from),
    createdTo: dateToParam(filters.dateCreated?.to),
  };
}
